'use client';

import { Blog, toc } from '@/commonTypes';
import React, { RefObject, useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';

import PageWrapper from '@/components/general/PageWrapper';

import { useLocale, useTranslations } from 'next-intl';

import BlogHead from './BlogHead';
import BlogBody from './BlogBody';

import SampleBlogs from '../../home/HomeContent/SampleBlogs';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { PageHero } from '@/components/general/PageHero';
import BlogInfo from './BlogInfo';
import BlogCover from '../../home/HomeContent/SampleBlogs/BlogCard/BlogCover';
import BlogShare from './BlogShare';
import BlogWriter from './BlogWriter';
import Comments from './Comments';

function addIdsToHeadingsInBody(htmlContent: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  const headings = Array.from(doc.body.querySelectorAll('h1, h2, h3, h4, h5, h6'));

  headings.forEach((tag, index) => {
    if (!tag.id) {
      const tagType = tag.tagName.toLowerCase();
      tag.id = `${tagType}-${index + 1}`;
      tag.className = `${tag.className} target-element`;
    }
  });

  return doc.body.innerHTML;
}

function generateTableOfContentsData(htmlContent: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  const headings = Array.from(doc.querySelectorAll('h1, h2, h3, h4, h5, h6'));

  const tocData: toc[] = [];

  headings.forEach((tag) => {
    if (!tag.id) {
      const tagType = tag.tagName.toLowerCase();
      tag.id = `${tagType}-${tocData.length + 1}`;
    }

    tocData.push({
      id: tag.id,
      title: tag.textContent?.trim() || '',
      level: parseInt(tag.tagName.charAt(1), 10),
    });
  });

  return tocData;
}
interface propsType {
  data?: Blog;
  content?: string;
  similarItems?: Blog[];
}
export default function SingleBlogContent({ data, content, similarItems = [] }: propsType) {
  const t = useTranslations('BlogPage.singleBlog');
  const locale = useLocale();
  const [blog, setBlog] = useState(data);
  useEffect(() => {
    setBlog(data);
  }, [data]);
  const [processedContent, setProcessedContent] = useState('');
  const [tocData, setTocData] = useState<toc[]>([]);
  const [activeId, setActiveId] = useState<string | undefined>('');

  const contentRef: RefObject<HTMLDivElement> = useRef(null);
  const tCommon = useTranslations('common');

  useEffect(() => {
    if (!content) return;

    const result = addIdsToHeadingsInBody(content);
    const toc = generateTableOfContentsData(result);

    setProcessedContent(result);
    setTocData(toc);
  }, [content]);

  useEffect(() => {
    if (!processedContent) return;

    const handleScroll = () => {
      if (!contentRef.current) return;

      const headings = Array.from(
        contentRef.current.querySelectorAll('h1, h2, h3, h4, h5, h6'),
      ) as HTMLElement[];

      if (!headings.length) return;

      const offset = 150; // adjust for sticky header

      let currentId = headings[0].id;

      for (const heading of headings) {
        const rect = heading.getBoundingClientRect();

        if (rect.top <= offset) {
          currentId = heading.id;
        } else {
          break;
        }
      }

      setActiveId((prev) => (prev !== currentId ? currentId : prev));
    };

    handleScroll();
    typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      window.addEventListener('scroll', handleScroll, {
        passive: true,
      });

    return () => {
      typeof window !== 'undefined' &&
        typeof document !== 'undefined' &&
        window.removeEventListener('scroll', handleScroll);
    };
  }, [processedContent]);
  //   useEffect(() => {
  //     const cookieName = `viewproduct-${data?.id}-${locale}`;
  //     let viewCookie = CookieFunction('get', cookieName);
  //     if (!viewCookie && data?.id) {
  //       Api.addView(data?.id)
  //         .then((res) => {
  //           CookieFunction('set', cookieName, data?.id, 0.00138888889);
  //         })
  //         .catch((err) => {});
  //     }
  //   }, []);
  return (
    <div className={`${styles.wrap}`}>
      <PageWrapper className={`p-0`}>
        <ViewportWrapper className={`w-full`}>
          <PageHero className={` ${styles.bottomPadding}`}>
            <div className={`${styles.blogMeta}`}>
              <div className={`${styles.heroRight}`}>
                <BlogHead data={blog} />
                <BlogInfo data={blog} />
              </div>
              <BlogCover item={blog} className={`${styles.blogCover}`} size="full" />
            </div>
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>

      <PageWrapper className={`w-full section-light mt-0 p-0`}>
        <ViewportWrapper className={`container`}>
          <BlogShare data={blog} />
          {/* <BlogCover item={blog} className={`${styles.blogCover}`} size="full" /> */}
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full section-light mt-0 p-0`}>
        <BlogBody
          data={blog}
          tocData={tocData}
          processedContent={processedContent ? processedContent : content}
          activeId={activeId}
          setActiveId={setActiveId}
          contentRef={contentRef}
        />
      </PageWrapper>
      <PageWrapper className={`w-full section-light mt-0 p-0`}>
        <div className={`container`}>
          <BlogWriter data={blog} />
        </div>
      </PageWrapper>
      <PageWrapper className={`w-full section-light mt-0 p-0`}>
        <div className="container py-0  mb-18">
          <Comments target="blog" targetId={blog?.id} showAllRates={false} showRateTitle={true} />
        </div>
      </PageWrapper>
      <PageWrapper className={`w-full section-paper mt-0 p-0`}>
        <div className="container py-0">
          <SampleBlogs
            title="مطالب مشابه"
            href={`/blogs?category=${blog?.category?.slug}`}
            tag={undefined}
            groupSlug={blog?.category?.slug}
          />
        </div>
      </PageWrapper>
      {/* 

        <BlogWriter data={blog} />
        <SampleBlogs /> */}
    </div>
  );
}
